import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useRefProductHandler(props, emit) {
    // ------------------------------------------------
    // taskLocal
    // ------------------------------------------------
    const refProductLocal = ref(JSON.parse(JSON.stringify(props.product.value)))
    const resetRefProductLocal = () => {
      refProductLocal.value = JSON.parse(JSON.stringify(props.product.value))
    }
    watch(props.product, () => {
      resetRefProductLocal()
    })
  
    // ------------------------------------------------
    // isEventHandlerSidebarActive
    // * Clear form if sidebar is closed
    // ! We can hide it using @hidden event
    // ------------------------------------------------
    // watch(props.isEventHandlerSidebarActive, val => {
    //   // ? Don't reset event till transition is finished
    //   if (!val) {
    //     setTimeout(() => {
    //       clearForm.value()
    //     }, 350)
    //   }
    // })
  
    const onSubmit = () => {
      const refProductData = JSON.parse(JSON.stringify(refProductLocal))
  
      // * If event has id => Edit Event
      // Emit event for add/update event
      if (props.product.value.id) emit('update-ref-product', refProductData.value)
      else emit('add-ref-product', refProductData.value)
  
      // Close sidebar
      emit('update:is-add-new-ref-product-sidebar-active', false)
    }
  
  
    return {
      // fetchCategories,
      // fetchProducts,
      // fetchTags,
      // fetchPriorities,
      // fetchTeams,
      // fetchUsers,
      refProductLocal,
      resetRefProductLocal,
      onSubmit,
    }
  }